export class BoundedValue {
  
  constructor(public value: number, public min: number, public max: number) {}

  setValue(newValue: number) {
    if (newValue < this.min) {
      this.value = this.min;
      //throw new Error(`Value out of bounds: ${newValue} not in [${this.min}, ${this.max}]`);
    }
    if ( newValue > this.max) {
      this.value = this.max;
      //throw new Error(`Value out of bounds: ${newValue} not in [${this.min}, ${this.max}]`);
    }
    this.value = newValue;
  }

  isValid() {
    return this.value >= this.min && this.value <= this.max;
  }
  
  static cloneFrom(original: BoundedValue): BoundedValue {
    return new BoundedValue(original.value, original.min, original.max);
  }
}
